export function makeLink(link: string): string {
  if (link.startsWith("http")) {
    return link;
  }

  return "https://" + link;
}
